
import { Component } from "vue-property-decorator";
import { ProjectView } from "@/views/project-view";
import { ObjectHelper, QuickHelper } from "@root/core";

@Component
export default class extends ProjectView {
    quick = this.quicks().FailedJob;

    errorStatusFilter = "CRITICAL";

    get ObjectHelper() {
        return ObjectHelper;
    }
    get QuickHelper() {
        return QuickHelper;
    }

    get tableParams() {
        const where: Record<string, any> = {};
        if (this.errorStatusFilter === "completed") {
            where.status = "COMPLETED";
        } else if (this.errorStatusFilter !== "all") {
            where.errorStatus = this.errorStatusFilter;
        }
        return { where };
    }
}
